import { Typography } from '@/components';
import { FormFieldContainer } from '@/components/Form/Form.styles';
import ErrorMessage from '@/components/FormField/components/ErrorMessage';
import { CheckboxWrapper } from '@/components/FormField/components/FormFieldType/Checkbox/Checkbox.styles';
import { TextInputWrapper } from '@/components/FormField/components/FormFieldType/Input/Input.styles';
import { LoginButtonWrapper } from '@/components/SsoLoginButton/SsoLoginButton.styles';
import { TextStyles } from '@/constants';
import { DividedLine, DividedText, DividerWrapper } from '@/modules/pmt/components/Divider/Divider.style';
import styled from 'styled-components';

const clampText = `
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

export const PopupContentWrapper = styled.div(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  background: theme.colors.highEmphasisWhite,
  wordBreak: 'break-word',
  padding: theme.spacing[20],

  [`${theme.mediaBreakpointUp.lg}`]: {
    padding: theme.spacing[32],
    justifyContent: 'center',
  },

  [LoginButtonWrapper]: {
    width: '100%',
  },

  [TextInputWrapper]: {
    marginTop: 0,
  },

  [FormFieldContainer]: {
    margin: 0,
    [CheckboxWrapper]: {
      marginTop: theme.spacing[16],
    },
  },

  [ErrorMessage]: {
    marginBottom: 0,
  },

  [DividerWrapper]: {
    marginTop: theme.spacing[20],
    marginBottom: theme.spacing[16],
  },

  [DividedText]: {
    color: theme.colors.mediumEmphasisBlack,
  },

  [DividedLine]: {
    backgroundColor: theme.colors.pressedBlack,
  },
}));

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[16]};
  margin-bottom: ${({ theme }) => theme.spacing[16]};
`;

export const Badge = styled(Typography).attrs({
  variant: TextStyles['Overline'],
})`
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.highEmphasisWhite};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.letterSpacing[75]};
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[8]}`};
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 1'],
})`
  ${clampText}
  -webkit-line-clamp: 2;
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const Subtitle = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  ${clampText}
  -webkit-line-clamp: 2;
  color: ${({ theme }) => theme.colors.mediumEmphasisBlack};
`;
